import { render, staticRenderFns } from "./MessageBodyNode.vue?vue&type=template&id=1a029f3e&scoped=true&lang=pug&"
import script from "./MessageBodyNode.vue?vue&type=script&lang=js&"
export * from "./MessageBodyNode.vue?vue&type=script&lang=js&"
import style0 from "./MessageBodyNode.vue?vue&type=style&index=0&id=1a029f3e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a029f3e",
  null
  
)

component.options.__file = "MessageBodyNode.vue"
export default component.exports